import React, {useState} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors, SETTING_TYPES} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import { getFaqSettingsItemAction, updateFaqSettingsAction } from '../../../actions/faqAction';
import { InputProfile } from '../../../utils/input/InputProfile';

export function FaqSettingsModal({item, trigger, triggerWrap, onSuccess}) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    id: item ? item.id : '',
    settings_type: item ? item.settings_type : SETTING_TYPES.DEFAULT,
    title: item ? item.title : '',
    uniq_name: item ? item.uniq_name : '',
    value: item ? item.value : ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
    if (value) {
      if (item) {
        setLoading(true);
        dispatch(getFaqSettingsItemAction(item.id)).then((data) => {
          setLoading(false);
          setForm(data);
        }).catch((e) => {
          setLoading(false);
          setOpen(false);
          toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        });
      } else {
        setForm({
          id: '',
          settings_type: SETTING_TYPES.DEFAULT,
          title: '',
          uniq_name: '',
          value: ''
        });
      }
    }
  };

  const handleChangeForm = (field, value) => {
    setForm((form) => {
      return {...form, [field]: value};
    });
  };

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    let err = false;
    let errors = {};
    if (form.uniq_name.trim() === '') {
      err = true;
      errors.uniq_name = true;
    }

    setErrors(errors);
    if (err) {
      return false;
    }
    setLoading(true);

    dispatch(updateFaqSettingsAction(form)).then(() => {
      setLoading(false);
      setOpen(false);
      onSuccess();
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={triggerWrap}>
    <React.Fragment>
      <div className="modal__title">{item ? "Изменить" : "Добавить"} настройку</div>
      <div className="modal__wrap">
        <InputProfile type="text"
                                title="Название"
                                name="title"
                                placeholder="Введите название"
                                value={form.title}
                                error={errors.title || false}
                                disabled={loading}
                                onChange={(e) => handleChangeForm('title', e.target.value)}/>  
        <InputProfile type="text"
                                title="Уникальное имя"
                                name="uniq_name"
                                placeholder="Введите уникальное имя"
                                value={form.uniq_name}
                                error={errors.uniq_name || false}
                                disabled={loading}
                                onChange={(e) => handleChangeForm('uniq_name', e.target.value)}/>  
        <InputProfile type="textarea"
                                title="Значение"
                                name="value"
                                placeholder="Введите значение"
                                value={form.value}
                                error={errors.value || false}
                                disabled={loading}
                                rows={10}
                                onChange={(e) => handleChangeForm('value', e.target.value)}/>
      </div>
      <div className="modal__btns">
        <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Сохранить</button>
      </div>
    </React.Fragment>
  </Modal>
};
